<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <b-card class="mx-auto col-8 border-0">
      <b-card-title>
        <div
          class="row"
          style="padding-left: 10px;"
        >
          <div class="survey-type-badge bg-default">
            <span class="icon-bullet-list" />
          </div>
          <div class="col-8">
            <strong>GDQ: </strong>Volvo Mätning 1 - Contact Members
            <p style="font-size: 0.7em;">
              <span class="icon-users" />&nbsp;Volvo Ledningsgrupp
            </p>
          </div>
        </div>
      </b-card-title>
      <h4>Select Message</h4>
      <b-form-group>
        <b-form-radio
          model="message"
          value="invitation"
        >
          Send the invitation message
        </b-form-radio>
        <b-form-radio
          model="message"
          value="reminder"
        >
          Send a reminder
        </b-form-radio>
        <b-form-radio
          model="message"
          value="adhoc"
        >
          Create and send a new message
        </b-form-radio>
      </b-form-group>
      <h4>Select Members</h4>
      <p>Please select the members you wish to contact from the list below</p>
      <GroupMembers />
    </b-card>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import GroupMembers from './GroupMembers.vue'

export default {
  name: 'ContactGroupMembers',
  components: {
    Navbar,
    Breadcrumb,
    GroupMembers
  }
}
</script>
<style scoped>
</style>
